
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.623 17.306h2.86a4.54 4.54 0 004.42 3.525c2.159 0 3.969-1.514 4.419-3.525h24.286a1 1 0 001-.995 1 1 0 00-1-.996H23.322a4.531 4.531 0 00-8.839 0h-2.86a1 1 0 00-1 .996 1 1 0 001 .995zm7.28-3.524c1.399 0 2.539 1.135 2.539 2.529a2.538 2.538 0 01-2.54 2.529c-1.4 0-2.54-1.136-2.54-2.53a2.538 2.538 0 012.54-2.528zM47.618 28.855h-6.939a4.54 4.54 0 00-4.42-3.524 4.531 4.531 0 00-4.419 3.524H11.633a1 1 0 00-1 .995 1 1 0 001 .996H31.84a4.531 4.531 0 008.839 0h6.939a1 1 0 001-.995 1 1 0 00-1-.996zm-11.369 3.524c-1.4 0-2.539-1.135-2.539-2.528a2.538 2.538 0 012.54-2.53c1.4 0 2.54 1.136 2.54 2.53.01 1.393-1.13 2.528-2.54 2.528zM30.17 42.395h17.448a1 1 0 011 .995 1 1 0 01-1 .996H30.17a4.531 4.531 0 01-4.42 3.524 4.54 4.54 0 01-4.42-3.524h-9.698a1 1 0 01-1-.996 1 1 0 011-.995h9.699a4.531 4.531 0 014.42-3.525 4.54 4.54 0 014.419 3.525zm-6.958.995a2.538 2.538 0 002.54 2.53c1.399 0 2.539-1.136 2.539-2.53a2.538 2.538 0 00-2.54-2.529c-1.4 0-2.54 1.136-2.54 2.53z"}})])
          )
        }
      }
    